import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, screenGutterProperty } from '@mgmresorts/wcl-styled';
import { FlexColumn } from './FlexColumn.es.js';

var _templateObject;
var GridColumn = styled(FlexColumn)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), screenGutterProperty('padding-left', 0.5), screenGutterProperty('padding-right', 0.5));

export { GridColumn };
